// getCurrentPosition never settles this promise on its own when permission
// is denied/unavailable (no error callback = no reject, so an `await` on
// this would hang forever) — that's the bug being fixed here. Callers
// (getRequestBaseData) already try/catch this expecting it to fail fast,
// which it now does within 5s instead of never.
export const getGeolocationData = () => {
    return new Promise(function (fulfilled, rejected) {
        if (!navigator.geolocation) {
            rejected(new Error("Geolocation not supported"));
            return;
        }
        navigator.geolocation.getCurrentPosition(fulfilled, rejected, { timeout: 5000 });
    });
}